import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {  Subscription } from 'rxjs';
import {LoginManager} from '../../_managers/login-manager.services';
import { User } from './../../_models/sesion/user';

@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit {
  refNativagate = new Subscription();
  currentUser: User;
  login:any;
  constructor(private loginManager: LoginManager, private router: Router) { }

  ngOnInit() {
    /*this.validateLogin();
    this.refNativagate = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.validateLogin();
      }
    });*/
    /*this.refNativagate.add(this.loginManager.getListToken().subscribe
      (list => {
        this.login = list;
        console.log(this.login.decode,this.login.decode);
        if(this.login.decode===1 || !this.login.decode){
          this.loginManager.Logout();
        }
      }));*/
    this.loginManager.currentUser.subscribe(x => this.currentUser = x);
    this.loginManager.isToken();
  }


  validateLogin() {
    /*let login = this.authenticationService.isLogin();*/
    let login= this.loginManager.isLogin();
    if (!login) {
      this.router.navigate(['/login']);
    }
  }
}
